/* tslint:disable */
/**
* Kronos Api
* No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
*
* OpenAPI spec version: v1
* 
*
* NOTE: This class is auto generated by the swagger code generator program.
* https://github.com/swagger-api/swagger-codegen.git
* Do not edit the class manually.
*/


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { HoursDifferenceOverviewDto } from '../model/hoursDifferenceOverviewDto';
import { HoursMonthlyOverviewDto } from '../model/hoursMonthlyOverviewDto';
import { HoursMonthlyOverviewRequest } from '../model/hoursMonthlyOverviewRequest';
import { HoursWeeklyOverviewDto } from '../model/hoursWeeklyOverviewDto';
import { WeeklyOverviewHoursRequest } from '../model/weeklyOverviewHoursRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class HoursService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDifference(observe?: 'body', reportProgress?: boolean): Promise<HoursDifferenceOverviewDto>;
    public getDifference(observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<HoursDifferenceOverviewDto>>;
    public getDifference(observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<HoursDifferenceOverviewDto>>;
    public getDifference(observe: any = 'body', reportProgress: boolean = false ): Promise<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/hour/overview/difference`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOverview(body: HoursMonthlyOverviewRequest, observe?: 'body', reportProgress?: boolean): Promise<HoursMonthlyOverviewDto>;
    public getOverview(body: HoursMonthlyOverviewRequest, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<HoursMonthlyOverviewDto>>;
    public getOverview(body: HoursMonthlyOverviewRequest, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<HoursMonthlyOverviewDto>>;
    public getOverview(body: HoursMonthlyOverviewRequest, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getOverview.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/hour/overview/month`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWeeklyOverview(body: WeeklyOverviewHoursRequest, observe?: 'body', reportProgress?: boolean): Promise<HoursWeeklyOverviewDto>;
    public getWeeklyOverview(body: WeeklyOverviewHoursRequest, observe?: 'response', reportProgress?: boolean): Promise<HttpResponse<HoursWeeklyOverviewDto>>;
    public getWeeklyOverview(body: WeeklyOverviewHoursRequest, observe?: 'events', reportProgress?: boolean): Promise<HttpEvent<HoursWeeklyOverviewDto>>;
    public getWeeklyOverview(body: WeeklyOverviewHoursRequest, observe: any = 'body', reportProgress: boolean = false ): Promise<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getWeeklyOverview.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/hour/overview/week`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).toPromise();
    }

}
